/* Structural layout only — colors come from Astryx design tokens (resolved
   inside a <Theme> scope), and are owned by the children (NavRail, main
   content), not this shell. */

.layout {
  display: flex;
  align-items: stretch;
  gap: var(--spacing-4);
  /* Not `overflow: hidden` anywhere in this chain — NavRail's expanded
     overlay is position:absolute and must be able to float out over
     .main without being clipped. */
  position: relative;
  overflow: visible;
}

.rail {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
}

.main {
  flex: 1;
  min-width: 0;
}

@media (max-width: 720px) {
  .layout {
    flex-direction: column;
  }

  .rail {
    width: 100%;
  }
}
